import { render } from "./TokenPayment.vue?vue&type=template&id=6afaa8ff&scoped=true"
import script from "./TokenPayment.vue?vue&type=script&lang=js"
export * from "./TokenPayment.vue?vue&type=script&lang=js"

import "./TokenPayment.vue?vue&type=style&index=0&id=6afaa8ff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afaa8ff"]])

export default __exports__